module.exports = __webpack_public_path__ + "static/img/SFI-Logo.1034da7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header/SFI-Logo.png
// module id = MTBZ
// module chunks = 1